import { render, staticRenderFns } from "./component-text.vue?vue&type=template&id=1d92c6f8&lang=pug&"
import script from "./component-text.vue?vue&type=script&lang=js&"
export * from "./component-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports